import React, { useMemo } from 'react';
import './AuthorChart.css';

export default function AuthorChart({ books }) {
  const chartData = useMemo(() => {
    return books.map(book => ({
      title: book.title.length > 15 ? book.title.slice(0, 15) + '...' : book.title,
      likes: book.likes,
      views: book.views,
      chapters: book.chapters.length,
      avgRating: book.ratings ? (() => {
        const vals = Object.values(book.ratings);
        return vals.length > 0 ? (vals.reduce((a, b) => a + b, 0) / vals.length).toFixed(1) : 0;
      })() : 0,
    }));
  }, [books]);

  if (chartData.length === 0) return null;

  const maxLikes = Math.max(...chartData.map(d => d.likes), 1);
  const maxViews = Math.max(...chartData.map(d => d.views), 1);

  return (
    <div className="author-chart-bars">
      {chartData.map((book, i) => (
        <div key={i} className="author-chart-item">
          <span className="author-chart-label">{book.title}</span>
          <div className="author-chart-bar-group">
            <div className="author-chart-bar-row">
              <span className="author-chart-bar-label">❤️</span>
              <div className="author-chart-bar-bg">
                <div
                  className="author-chart-bar-fill author-chart-likes"
                  style={{ width: (book.likes / maxLikes * 100) + '%' }}
                />
              </div>
              <span className="author-chart-bar-value">{book.likes}</span>
            </div>
            <div className="author-chart-bar-row">
              <span className="author-chart-bar-label">👁</span>
              <div className="author-chart-bar-bg">
                <div
                  className="author-chart-bar-fill author-chart-views"
                  style={{ width: (book.views / maxViews * 100) + '%' }}
                />
              </div>
              <span className="author-chart-bar-value">{book.views}</span>
            </div>
          </div>
          <div className="author-chart-meta">
            <span>{book.chapters} chap.</span>
            {book.avgRating > 0 && <span>⭐ {book.avgRating}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}